// Shared application constants

/** Delivery fee in MXN pesos added when the customer chooses home delivery. */
export const DELIVERY_FEE = 200;

/** How long the product card's "¡Agregado!" button feedback stays visible, in ms. */
export const ADD_TO_CART_FEEDBACK_MS = 900;

/** How long the cart badge's blink animation runs, in ms. */
export const CART_BADGE_BLINK_MS = 600;
